<template>
    <div class="roho-about">
        <section class="main-section">
            <div class="bar">
                <img src="/img/brand/roho-icon-only.png" alt="">
                <router-link to="/"><base-button
					tag="button"
					icon="fa fa-home"
					type="roho-blue">Home</base-button></router-link>
            </div>
            <div class="frame">
                <div class="content">
                    <h1>A Diverse Team For A Great Cause</h1>
                    <p>Meet the faces behind Roho Network, the people driving it's mission forward.</p>
                    <div class="image-grid">
                        <img v-for="(member, index) in team" :key="member.name" v-if="index%2 == 0" :src="member.image">
                    </div>
                    <div class="image-grid bottom">
                        <img v-for="(member, index) in team" :key="member.name" v-if="index%2 == 1" :src="member.image">
                    </div>

                    <base-button
                        class="scroll-btn"
                        tag="button"
                        :outline="true"
                        icon="fa fa-arrow-circle-down"
                        href="/volunteer/create"
                        type="roho-blue"
                        v-scroll-to="{
                            el: '#explore',
                            offset: 0,
                            duration: 500
                        }">
                        Explore
                    </base-button>
                </div>
            </div>
        </section>
        <section id="explore" class="team-section">
            <div v-for="member in team" :key="member.name" class="roho-member-box">
                <img :src="member.image" alt="">
                <div class="text-content">
                    <h2>{{ member.name }}</h2>
                    <h3>{{ member.title}}</h3>

                    <p>{{ member.description }}</p>

                    <a :href="member.linkedin" target="_blank">View Linkedin</a>
                </div>
            </div>
        </section>
        <section class="interest-section">
            <h3>Interested In Working With Us?</h3>
            <div>
                <router-link to="volunteer/create"><base-button
					tag="button"
					icon="fa fa-sign-in"
					type="roho-blue">Join Now</base-button></router-link>
                <base-button
                    tag="a"
                    :outline="true"
                    icon="fa fa-envelope"
                    href="mailto:emily@rohonetwork.com"
                    type="roho-blue">
                    Contact
                </base-button>
            </div>
        </section>
        <section class="footer-section">
            <img src="/img/brand/roho-icon-only.png" alt="">
            <router-link to="/"><base-button
                tag="button"
                icon="fa fa-home"
                type="roho-blue">Home</base-button></router-link>
        </section>
    </div>
</template>

<script>
export default {
    data() {
        return {
            team: [
                {
                    name: 'Emily Sha',
                    title: 'Co-Founder, Team Lead',
                    description: 'Emily an innovator and entrepreneur with experience in startups, health, and community organising. She worked on the Innovation and Sustainability Teams at the UN-International Atomic Energy Agency. This is her third venture.',
                    image: '/img/team/emily.png',
                    linkedin: 'https://www.linkedin.com/in/emily-sha-3487a91a/'
                },
                {
                    name: 'Lindsay Bryda',
                    title: 'Co-Founder, Operations',
                    description: 'Lindsayis a Fulbright Alum to Bosnia and Herzegovina and holds a Political Science degree from Clemson University. She worked for the U.S. Department of State in Austria and China.',
                    image: '/img/team/lindsay.png',
                    linkedin: 'https://www.linkedin.com/in/lindsaybryda/'
                },
                {
                    name: 'Brooke Swanson',
                    title: 'Tech Lead',
                    description: 'Brooke is a security-focused Software Engineer with a Bachelor’s in Applied Mathematics and Economics from the University of Wisconsin Madison.',
                    image: '/img/team/brooke.jpg',
                    linkedin: 'https://www.linkedin.com/in/brooke-swanson-b28bab111/'
                },
                {
                    name: 'Dr. Nathan Uchtman',
                    title: 'Lawyer & Physician',
                    description: 'Nathan is a physician, attorney and environmentalist. He served as  Harvard’s Clinicians for Planetary Health Partnerships Manager. He partnered with underserved communities to promote health equity through the University of California HEAL Global Health Fellowship.',
                    image: '/img/team/juan.png',
                    linkedin: 'https://www.linkedin.com/in/nathaniel-uchtmann-277b7649/'
                },
                {
                    name: 'Daniel Putzer',
                    title: 'Design & Software',
                    description: 'Daniel is an aspiring Data Scientist completing a Bachelor’s degree in International Economics at the Vienna University of Economics and Business. He currently works as a Frontend Developer and UI Designer for a Vienna-based start-up.',
                    image: '/img/team/daniel.jpg',
                    linkedin: 'https://www.linkedin.com/in/danielputzer/'
                },
                {
                    name: 'Nightingale Uchtmann',
                    title: 'One Health Advocate',
                    description: 'Nightingale is a Kenyan changemaker and public health nurse. She is the Executive Director for Cocoa-Eye, a Liberian One Health NGO. They reduce the risk of animal-to-human disease transmission through poaching prevention, restorative agriculture and public health campaigns. ',
                    image: '/img/team/nightingale.jpg',
                    linkedin: 'https://www.linkedin.com/in/nightingale-uchtmann-b18b0247/'
                },
                {
                    name: 'Dr. Jesús Puerta',
                    title: 'Optimization',
                    description: 'Jesús holds a PhD in Automation and Robotics from the Technical University of Madrid (UPM). His background includes expertise in optimisation, data science and feedback control systems.',
                    image: '/img/team/jesus.jpg',
                    linkedin: 'https://www.linkedin.com/in/jespestana/'
                },
                {
                    name: 'Stefania Martello',
                    title: 'Business Analyst & Strategy',
                    description: 'Stefania is a Monitoring and Statistics Expert with a Master’s in Statistics from the University of Palermo. She has improved the impact of development work through mixed-methods research, evaluation studies and data analysis with NEXT, New Energies for the Territory and UNIDO.',
                    image: '/img/team/stefania.jfif',
                    linkedin: 'https://www.linkedin.com/in/stefania-martello-31b3a3173/'
                },
                {
                    name: 'Dolores Zurdo',
                    title: 'Quality Assurance',
                    description: 'Dolores is an Industrial Engineering and Master of Science in Industrial Organization Specialization by the Technical University of Madrid. She has extensive experience in software quality assurance.',
                    image: '/img/team/dolores.jpg',
                    linkedin: 'https://www.linkedin.com/in/doloreszurdo/'
                }
            ]
        }
    }
}
</script>

<style lang="scss">

    .roho-about {
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #F5F9FF;

        .scroll-btn {
            border: none;
        }

        section {
            position: relative;
            width: 90%;
            max-width: 1040px;
            text-align: center;

            h1 {
                font-size: 28px;
                font-weight: 700;
            }

            p {
                font-size: 18px;
                margin: 0 0 35px 0;
            }
        }

        .bar {
            position: absolute;
            display: flex;
            width: 100%;
            top: 25px;

            img {
                width: 45px;
                margin: 0 auto 0 0;
            }
        }

        .content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100vh;

            .scroll-btn {
                position: absolute;
                bottom: 60px;
            }
        }

        .image-grid {
            display: grid;
            grid-template-columns: 60px 60px 60px 60px 60px;
            column-gap: 12px;

            &.bottom {
                grid-template-columns: 60px 60px 60px 60px;
                margin: 12px 0 0 0;
            }

            img {
                width: 100%;
                border-radius: 6px;
            }
        }

        .roho-member-box {
            display: flex;
            background: white;
            align-items: center;
            min-height: 340px;
            padding: 20px;
            margin: 0 0 50px 0;
            border-radius: 10px;
            box-shadow: 0 0 30px 0px rgba($color: #B4C7E5, $alpha: 0.15);
            text-align: left;

            img {
                height: 300px;
                border-radius: 10px;
                margin: 0 40px 0 0;
                flex-shrink: 0;
                align-self: flex-start;
            }

            h2 {
                font-size: 24px;
            }

            h3 {
                font-size: 16px;
                opacity: 0.75;
                margin: 0 0 15px 0;
            }

            &:first-of-type {
                margin-top: 100px;
            }
        }

        .interest-section {
            display: flex;
            align-items: center;
            flex-direction: column;
            max-width: none;
            background: white;
            width: 100%;
            padding: 70px;
            margin: 100px 0 0 0;

            h3 {
                margin: 0 0 30px 0;
            }

            button:first-of-type {
                margin: 0 20px 0 0;
            }
        }

        .footer-section {
            display: flex;
            width: 100%;
            padding: 40px 0;

            img {
                width: 45px;
                margin: 0 auto 0 0;
            }
        }
    }



    // Mobile Optimization

    @media (max-width: 768px) { 
        .roho-about {
            text-align: center;

            .image-grid {
                grid-template-columns: 50px 50px 50px 50px 50px;
                column-gap: 8px;

                &.bottom {
                    grid-template-columns: 50px 50px 50px 50px;
                    margin: 8px 0 0 0;
                }
            }

            .roho-member-box {
                flex-direction: column;
                padding-bottom: 40px;

                img {
                    height: auto;
                    width: 80vw;
                    margin: 0 0 30px 0;
                }

                h2 {
                    font-size: 22px;
                }

                h3 {
                    font-size: 14px;
                }

                &:first-of-type {
                    margin-top: 100px;
                }
            }

            .interest-section {
                margin: 50px 0 0 0;

                div {
                    display: flex;
                    flex-direction: column;
                }

                button:first-of-type {
                    margin: 0 0 10px 0;
                }
            }

            .footer-section {
                width: 90%;
            }
        }
    }

</style>